module.exports = __webpack_public_path__ + "img/item_rhodes.c10125c5.png";